import React from 'react'

export default function ProtectPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          d="M30.5 9.1v23.2c0 1.8-1.5 3.2-3.2 3.2H5.2C3.4 35.5 2 34 2 32.3v-28C2 2.5 3.4 1 5.2 1h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6 1 .6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="M15.973 29.37c-.164 0-.327-.054-.49-.108-.927-.327-3.27-1.254-5.396-3.216-1.199-1.09-2.18-2.398-2.834-3.76C6.436 20.596 6 18.69 6 16.673v-4.414c0-.709.436-1.308 1.144-1.472 4.088-1.09 6.976-2.833 8.011-3.542a1.577 1.577 0 0 1 1.69 0c1.035.709 3.923 2.507 8.01 3.542A1.52 1.52 0 0 1 26 12.26v4.414c0 2.016-.436 3.924-1.253 5.613-.654 1.417-1.635 2.67-2.834 3.76-2.125 1.962-4.469 2.889-5.395 3.216-.218.109-.382.109-.545.109Zm0-21.416c-.11 0-.218.054-.327.109-.6.436-1.635 1.09-3.052 1.744a30.28 30.28 0 0 1-5.232 1.961c-.272.055-.436.327-.436.545v4.414c0 1.908.382 3.652 1.145 5.178a11.69 11.69 0 0 0 2.67 3.487c2.017 1.853 4.196 2.725 5.068 2.998a.465.465 0 0 0 .382 0c.872-.273 3.052-1.2 5.068-2.998a12.417 12.417 0 0 0 2.67-3.487c.763-1.58 1.145-3.325 1.145-5.178v-4.414a.53.53 0 0 0-.436-.545c-1.799-.49-3.597-1.144-5.232-1.961-1.417-.654-2.398-1.308-3.052-1.744-.163-.11-.272-.11-.381-.11Z"
        />
        <path
          fill="currentColor"
          d="M11.777 18.09v4.469c0 .599.49 1.144 1.144 1.144h6.158c.6 0 1.145-.49 1.145-1.144v-4.47c0-.598-.491-1.143-1.145-1.143h-.436V15.31c0-.709-.272-1.363-.763-1.853a2.595 2.595 0 0 0-1.853-.763c-.708 0-1.362.272-1.853.763a2.595 2.595 0 0 0-.762 1.853v1.634h-.437c-.708 0-1.198.546-1.198 1.145Zm3.596 1.853c0-.327.273-.6.6-.6.327 0 .6.273.6.6 0 .218-.164.436-.382.545l.109.6c0 .108-.055.217-.164.217h-.327c-.109 0-.218-.109-.163-.218l.109-.6c-.218-.108-.382-.326-.382-.544Zm-1.308-4.632a1.93 1.93 0 0 1 1.908-1.908 1.93 1.93 0 0 1 1.907 1.908v1.634h-3.87v-1.634h.055Z"
        />
      </svg>
    </div>
  )
}
